import { Assets } from "../../../assets";

export const iconMap: Record<string, string> = {
  Opérateurs: Assets.images.operator,
  Matériels: Assets.images.material,
  "Capacité d'entreposage": Assets.images.capacity,
  "Respect des objectifs": Assets.images.task,
  "Occupation terre pleins": Assets.images.pile,
  "Occupation magasins": Assets.images.warehouse,
};

export const unitMap: Record<string, string> = {
  "Capacité d'entreposage": "%",
  "Respect des objectifs": "%",
  "Occupation terre pleins": "%",
  "Occupation magasins": "%",
};
